<template>
    <div>
        <div class="table-wrap">
            <table class="board_table">
                <thead>
                    <tr>
                        <th rowspan="3">날짜</th>
                        <th colspan="2">X</th>
                        <th colspan="2">블루스카이</th>
                        <th colspan="2">구글</th>
                        <th colspan="2">네이버</th>
                        <th colspan="2">유튜브</th>
                        <th colspan="2">인스타그램</th>
                        <th colspan="2">전체</th>
                    </tr>
                    <tr>
                        <th>검색</th>
                        <th>검색 결과</th>
                        <th>검색</th>
                        <th>검색 결과</th>
                        <th>검색</th>
                        <th>검색 결과</th>
                        <th>검색</th>
                        <th>검색 결과</th>
                        <th>검색</th>
                        <th>검색 결과</th>
                        <th>검색</th>
                        <th>검색 결과</th>
                        <th>검색</th>
                        <th>검색 결과</th>
                    </tr>
                </thead>
                <template v-if="!props.loading">
                    <tbody>
                        <tr v-for="value in props.chartData">
                            <td v-text="chartDateFormat2(value.date)"></td>
                            <td v-text="numberFormat(value.cntX)"></td>
                            <td v-text="numberFormat(value.cntResultX)"></td>
                            <td v-text="numberFormat(value.cntBluesky)"></td>
                            <td v-text="numberFormat(value.cntResultBluesky)"></td>
                            <td v-text="numberFormat(value.cntGoogle)"></td>
                            <td v-text="numberFormat(value.cntResultGoogle)"></td>
                            <td v-text="numberFormat(value.cntNaver)"></td>
                            <td v-text="numberFormat(value.cntResultNaver)"></td>
                            <td v-text="numberFormat(value.cntYoutube)"></td>
                            <td v-text="numberFormat(value.cntResultYoutube)"></td>
                            <td v-text="numberFormat(value.cntInstagram)"></td>
                            <td v-text="numberFormat(value.cntResultInstagram)"></td>
                            <td v-text="numberFormat(value.cntAll)"></td>
                            <td v-text="numberFormat(value.cntResultAll)"></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>총 계 (건)</td>
                            <td>{{ numberFormat(totalRow.cntX) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultX) }}</td>
                            <td>{{ numberFormat(totalRow.cntBluesky) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultBluesky) }}</td>
                            <td>{{ numberFormat(totalRow.cntGoogle) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultGoogle) }}</td>
                            <td>{{ numberFormat(totalRow.cntNaver) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultNaver) }}</td>
                            <td>{{ numberFormat(totalRow.cntYoutube) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultYoutube) }}</td>
                            <td>{{ numberFormat(totalRow.cntInstagram) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultInstagram) }}</td>
                            <td>{{ numberFormat(totalRow.cntAll) }}</td>
                            <td>{{ numberFormat(totalRow.cntResultAll) }}</td>
                        </tr>
                    </tfoot>
                </template>
                <tbody v-else>
                    <tr>
                        <td :colspan="16">
                            <Spinner />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="board_graph_list">
        <Chart style="height: 400px" v-for="data in chartData" :defaultLayout="chartLayout" :data="data"></Chart>
    </div>
</template>

<script lang="ts" config>
    import {
        Chart,
        numberFormat,
        reactive,
        LayoutOption,
        Spinner,
        ref,
        ChartData,
        setChartData,
        ChartSort,
        onMounted,
        watch,
        chartDateFormat2,
        computed,
    } from "@/BaseComponent";
    import { resultCntData } from "@/services/api/statistics";
    export default {
        props: ["loading", "chartData"],
        components: {
            Chart,
            Spinner,
        },
        setup(props: any) {
            const chartData = ref<ChartData[]>([]);
            const chartLayout = reactive({
                type: "line",
                xAxisKey: "date",

                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부
            } as LayoutOption);

            const searchCntChartSort: ChartSort[] = [
                // { name: "전체", valueKey: "cntAll" },
                { name: "X(구 트위터)", valueKey: "cntX" },
                { name: "블루스카이", valueKey: "cntBluesky" },
                { name: "구글", valueKey: "cntGoogle" },
                { name: "네이버", valueKey: "cntNaver" },
                { name: "유튜브", valueKey: "cntYoutube" },
                { name: "인스타그램", valueKey: "cntInstagram" },
            ];

            const resultCntChartSort: ChartSort[] = [
                { name: "전체", valueKey: "cntResultAll" },
                { name: "X(구 트위터)", valueKey: "cntResultX" },
                { name: "블루스카이", valueKey: "cntResultBluesky" },
                { name: "구글", valueKey: "cntResultGoogle" },
                { name: "네이버", valueKey: "cntResultNaver" },
                { name: "유튜브", valueKey: "cntResultYoutube" },
                { name: "인스타그램", valueKey: "cntResultInstagram" },
            ];

            // 플랫폼 별 차트 표기시 사용
            const platformChartSort: ChartSort[] = [
                { name: "검색 건수", valueKey: "searchCnt", chartType: "bar" },
                { name: "검색 결과", valueKey: "resultCnt" },
            ];

            const chartList = [
                { idx: 0, name: "전체", search: "cntAll", result: "cntResultAll" },
                { idx: 1, name: "X (구 트위터)", search: "cntX", result: "cntResultX" },
                { idx: 1, name: "블루스카이", search: "cntBluesky", result: "cntResultBluesky" },
                { idx: 2, name: "구글", search: "cntGoogle", result: "cntResultGoogle" },
                { idx: 3, name: "네이버", search: "cntNaver", result: "cntResultNaver" },
                { idx: 4, name: "유튜브", search: "cntYoutube", result: "cntResultYoutube" },
                { idx: 5, name: "인스타", search: "cntInstagram", result: "cntResultInstagram" },
            ];

            const totalRow = computed(() => {
                return {
                    cntX: props.chartData.reduce((sum: any, item: any) => sum + item.cntX, 0),
                    cntResultX: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultX, 0),
                    cntGoogle: props.chartData.reduce((sum: any, item: any) => sum + item.cntGoogle, 0),
                    cntResultGoogle: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultGoogle, 0),
                    cntNaver: props.chartData.reduce((sum: any, item: any) => sum + item.cntNaver, 0),
                    cntResultNaver: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultNaver, 0),
                    cntYoutube: props.chartData.reduce((sum: any, item: any) => sum + item.cntYoutube, 0),
                    cntResultYoutube: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultYoutube, 0),
                    cntInstagram: props.chartData.reduce((sum: any, item: any) => sum + item.cntInstagram, 0),
                    cntResultInstagram: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultInstagram, 0),
                    cntAll: props.chartData.reduce((sum: any, item: any) => sum + item.cntAll, 0),
                    cntResultAll: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultAll, 0),
                    cntBluesky: props.chartData.reduce((sum: any, item: any) => sum + item.cntBluesky, 0),
                    cntResultBluesky: props.chartData.reduce((sum: any, item: any) => sum + item.cntResultBluesky, 0),
                };
            });

            onMounted(() => {
                chartData.value = [];
                if (props.chartData) formatData(props.chartData);
            });

            watch(
                () => props.chartData,
                (newData) => {
                    chartData.value = [];
                    if (newData) formatData(newData);
                },
            );

            const formatData = (value: any) => {
                resultCntForType(value);
                // resultCntForPlatform(value);
            };

            const resultCntForType = (list: resultCntData[]) => {
                let searchCnt = list.map((item) => ({
                    date: item.date,
                    cntAll: item.cntAll,
                    cntX: item.cntX,
                    cntBluesky: item.cntBluesky,
                    cntGoogle: item.cntGoogle,
                    cntNaver: item.cntNaver,
                    cntYoutube: item.cntYoutube,
                    cntInstagram: item.cntInstagram,
                }));
                let resultCnt = list.map((item) => ({
                    date: item.date,
                    cntResultAll: item.cntResultAll,
                    cntResultX: item.cntResultX,
                    cntResultBluesky: item.cntResultBluesky,
                    cntResultGoogle: item.cntResultGoogle,
                    cntResultNaver: item.cntResultNaver,
                    cntResultYoutube: item.cntResultYoutube,
                    cntResultInstagram: item.cntResultInstagram,
                }));

                chartData.value.push(setChartData(searchCntChartSort, searchCnt, chartLayout.xAxisKey, "검색 수"));
                chartData.value.push(setChartData(resultCntChartSort, resultCnt, chartLayout.xAxisKey, "검색 결과 수"));
            };

            const resultCntForPlatform = (list: resultCntData[]) => {
                for (const sns of chartList) {
                    const data = list.map((item) => ({
                        date: item.date,
                        searchCnt: item[sns.search as keyof resultCntData],
                        resultCnt: item[sns.result as keyof resultCntData],
                    }));

                    chartData.value.push(setChartData(platformChartSort, data, chartLayout.xAxisKey, sns.name));
                }
            };

            return {
                props,
                totalRow,
                chartLayout,
                numberFormat,
                chartData,
                chartDateFormat2,
            };
        },
    };
</script>

<style scoped>
    .dp__input {
        width: 15%;
    }
    .board_graph_top {
        display: flex;
        gap: 20px;
    }
    .board_btn.board_ico_btn.active {
        background-color: var(--lightBlue) !important;
        color: #ffffff !important;
    }
    #board_layer .sch_box {
        height: 45px;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;

        border: 1px solid #dfdfdf;
        height: auto;
    }
    .board_graph_list {
        padding-top: 20px;
    }

    .table-wrap {
        max-height: 400px;
        overflow-y: auto;
    }

    /* 테이블 기본 */
    .board_table {
        width: 100%;
        border-collapse: collapse;
    }

    /* thead 고정 */
    .board_table thead {
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 1;
    }

    /* tfoot 고정 */
    .board_table tfoot {
        position: sticky;
        bottom: 0;
        background: #012f5c;
        border: 1px solid #dfdfdf;
        height: 24px;
    }

    .board_table tfoot td {
        font-size: 16px;
        font-weight: 700;
        color: #fff !important;
        height: 24px !important;
    }

    /* 보기 좋게 */
    th,
    td {
        padding: 8px;
        border: 1px solid #ddd;
    }

    div.table_head,
    div.table_body .tr,
    div.table_foot .tr {
        display: flex;
        justify-content: space-between;
    }

    div.table_head,
    div.table_foot {
        background: #012f5c;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
    }

    div.table_head > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
        /* width: 150px; */
    }

    div.table_foot > div {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
    }

    div.table_head > div > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 150px;
        margin-top: 10px;
    }
</style>
